import React, { FC } from 'react';
import SVGUniqueID from 'react-svg-unique-id';

interface CustomLoaderProps {
  width?: number;
  height?: number;
  className?: string;
}

const CustomLoaderIcon: FC<CustomLoaderProps> = ({
  width = 33,
  height = 33,
  className
}) => {
  return (
    <SVGUniqueID>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 33 33"
        fill="none"
        className={className}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.5 0C17.3284 0 18 0.671573 18 1.5V7.5C18 8.32843 17.3284 9 16.5 9C15.6716 9 15 8.32843 15 7.5V1.5C15 0.671573 15.6716 0 16.5 0Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.5 24C17.3284 24 18 24.6716 18 25.5V31.5C18 32.3284 17.3284 33 16.5 33C15.6716 33 15 32.3284 15 31.5V25.5C15 24.6716 15.6716 24 16.5 24Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 16.5C0 15.6716 0.671573 15 1.5 15H7.5C8.32843 15 9 15.6716 9 16.5C9 17.3284 8.32843 18 7.5 18H1.5C0.671573 18 0 17.3284 0 16.5Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24 16.5C24 15.6716 24.6716 15 25.5 15H31.5C32.3284 15 33 15.6716 33 16.5C33 17.3284 32.3284 18 31.5 18H25.5C24.6716 18 24 17.3284 24 16.5Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.8143 21.8143C22.4001 21.2286 23.3499 21.2286 23.9357 21.8143L28.1783 26.057C28.7641 26.6428 28.7641 27.5925 28.1783 28.1783C27.5925 28.7641 26.6428 28.7641 26.057 28.1783L21.8143 23.9357C21.2286 23.3499 21.2286 22.4001 21.8143 21.8143Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.1783 4.93925C28.7641 5.52504 28.7641 6.47479 28.1783 7.06057L23.9357 11.3032C23.3499 11.889 22.4001 11.889 21.8143 11.3032C21.2286 10.7174 21.2286 9.76768 21.8143 9.18189L26.057 4.93925C26.6428 4.35347 27.5925 4.35347 28.1783 4.93925Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.1857 21.8143C11.7714 22.4001 11.7714 23.3499 11.1857 23.9357L6.94302 28.1783C6.35723 28.7641 5.40749 28.7641 4.8217 28.1783C4.23591 27.5925 4.23591 26.6428 4.8217 26.057L9.06434 21.8143C9.65013 21.2286 10.5999 21.2286 11.1857 21.8143Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.8217 4.93925C5.40749 4.35347 6.35723 4.35347 6.94302 4.93925L11.1857 9.18189C11.7714 9.76768 11.7714 10.7174 11.1857 11.3032C10.5999 11.889 9.65013 11.889 9.06434 11.3032L4.8217 7.06057C4.23591 6.47479 4.23591 5.52504 4.8217 4.93925Z"
          fill="black"
        />
      </svg>
    </SVGUniqueID>
  );
};

export { CustomLoaderIcon };